import { Component, Input } from '@angular/core';
import { formatNumberWithDotSeparator } from '@valg-shared/utils/string-utils';
import { VotesDetails, VotingDetails, VotingDetailsList } from './voting-details.model';
import { CandidateDataLoadState, ResultSummaryDto, ResultType } from "@shared/clients/api.generated";

let NEXT_ID = 0;
@Component({
  selector: 'valg-dk-voting-details',
  templateUrl: './voting-details.component.html',
  styleUrls: [ './voting-details.component.scss' ]
})
export class VotingDetailsComponent {
  static readonly dashString: string = "-";
  @Input() data?: VotingDetails;
  @Input() list: VotingDetailsList[] = [];
  @Input() resultType?: ResultType;
  @Input() candidateDataLoadState?: CandidateDataLoadState;
  @Input() resultSummary?: ResultSummaryDto; 
  @Input() isElectionArea = false;
  @Input() isMigratedElection = false;

  public id: string = 'valg-voting-details-' + NEXT_ID++;
  public formatNumberWithDotSeparator = formatNumberWithDotSeparator;
  
  get shouldShowVoteDifferenceColumn(): boolean {
    return !(this.isElectionArea && this.isMigratedElection);
  }

  formatDiff(value: VotesDetails): string{
    if(value.diff === undefined){
      return '';
    }
    if (value.diff === null) {
      return VotingDetailsComponent.dashString;
    }
    if(value.diff > 0){
      return '+' + formatNumberWithDotSeparator(value.diff);
    }
    return formatNumberWithDotSeparator(value.diff);
  }

  getVoteNumberDisplay(votes: number){
    return this.resultType == ResultType.NoResults ? VotingDetailsComponent.dashString : formatNumberWithDotSeparator(votes)
  }


}
